<template lang="pug">
    div
        Card.a8-page-description-card 
            Row(type="flex" align="middle" justify="space-between")
                Col(:xl="20" :lg="16")
                    h2 {{$t('routesMenu.FQDNConfig')}}
                    p(v-if="$store.getters.getDomainConfig.domainWithNoneAppProfile") An FQDNConfig is either an AppProfile or a domain with AppProfile 'none'. We recommend using AppProfile to categorized your business.
                    strong You have created: {{ usage.FQDNConfig.used }} of {{ usage.FQDNConfig.max }} FQDNConfigs and {{ usage.fqdns.used }} of {{ usage.fqdns.max }} FQDNs.
                Col
                    ExplainBtn(:objectExplanation="objectsExplanation") 
                Col(:xl="4" :lg="8")
                    RadioGroup(:value="$route.path" @on-change="gotoRoute" :style="{'width': '100%'}" vertical)
                        Radio(label="/fqdn-config/app-profile" border)
                            Span {{ $t("routesMenu.AppProfile") }}
                        Radio(label="/fqdn-config/domainsetting" border v-if="$store.getters.getDomainConfig.domainWithNoneAppProfile")
                            Span {{ $t("routesMenu.DomainManage") }}
        router-view
</template>
<script>
import bus from "@/libs/bus.js";
import { getGroupAsset } from "@/api/groupasset.js";

export default {
    name: "FQDNConfig",
    components: {},
    data() {
        return {
            // esIndex: "app-profile",
            objectsExplanation: {},
            usage: {
                FQDNConfig: {
                    used: "",
                    max: "",
                    available: ""
                },
                fqdns: {
                    used: "",
                    max: "",
                    available: ""
                }
            }
        };
    },
    computed: {
        esIndex() {
            if (this.$route.path !== "/fqdn-config/app-profile") {
                return "domainsetting";
            }
            return "app-profile";
        }
    },
    watch: {
        "$i18n.locale": {
            deep: true,
            handler: function() {
                this.objectsExplanation = this.$i18n.t("objectExplanation." + this.esIndex);
            }
        }
    },
    methods: {
        getAssetData() {
            getGroupAsset({
                category: "FQDNConfigs",
                groupNames: [this.$store.state.queryGroupName]
            }).then(res => {
                let { used, max } = res.data;
                let available = max - used;
                this.usage.FQDNConfig = { used, max, available };
            });
            getGroupAsset({
                category: "fqdns",
                groupNames: [this.$store.state.queryGroupName]
            }).then(res => {
                let { used, max } = res.data;
                let available = max - used;
                this.usage.fqdns = { used, max, available };
            });
        },
        gotoRoute(path) {
            let routeTo = { path };
            let { groupName } = this.$route.query;
            if (groupName) routeTo.query = { groupName };
            this.$router.push(routeTo);
        }
    },
    mounted() {
        this.getAssetData();
    },
    created() {
        this.objectsExplanation = this.$i18n.t("objectExplanation." + this.esIndex);
        this.$bus = bus;
        // 監聽以自己組件為名的事件
        bus.$on(this.$options.name, (busEvent, args) => {
            // 如果是找我的事件就接收處理, 否則向下傳遞
            switch (busEvent) {
                case "":
                    break;
                default:
                    bus.$emit(busEvent);
                    break;
            }
        });
    },
    destroyed() {},
    beforeDestroy() {
        bus.$off(this.$options.name);
    }
};
</script>



// WEBPACK FOOTER //
// src/view/FQDNConfig/Page.vue